import { GET_GEOSERVER_SITES } from '../constants/constants';
import apiClient from './api_axios_instance.function';
import { handleApiError } from './errorHandler.function';

export const geoServerSites = async (network, signal) => {
  try {
    // Validate network parameter
    if (!network) {
      console.warn('Network parameter is required for geoServerSites');
      return null;
    }

    const resp = await apiClient.get(GET_GEOSERVER_SITES(network), {
      signal,
      timeout: 30000, // 30 second timeout
    });

    return resp.data;
  } catch (error) {
    if (error.code === 'ERR_CANCELED' || error.name === 'AbortError') {
      console.log('Request cancelled for network:', network);
      return null;
    }

    if (error.code === 'ECONNABORTED') {
      console.log('Request timeout for network:', network);
      return null;
    }

    handleApiError(error);
    return null;
  }
};
